import { splitProps } from 'solid-js';
export const createSplitProps = () => (props, keys) => splitProps(props, keys);
